import { render } from "./_content.vue?vue&type=template&id=4a531f4f"
import script from "./_content.vue?vue&type=script&lang=js"
export * from "./_content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__